import type {
    EmployeeProfileDropdownProps,
} from "../../contacts-search-profiles/components/EmployeeProfileDropdown/EmployeeProfileDropdown";
import EmployeeProfileDropdown from "../../contacts-search-profiles/components/EmployeeProfileDropdown/EmployeeProfileDropdown";

type SenioritiesDropdownProps = { onSelect(selectedIds: readonly string[]): void } & Omit<
    EmployeeProfileDropdownProps,
    "onAdd" | "onRemove" | "id"
>;

const SenioritiesDropdown = ({ onSelect, selectedIds = [], ...rest }: SenioritiesDropdownProps) => {
    function handleAdd(id: string) {
        onSelect(selectedIds.concat(id));
    }

    function handleRemove(id: string) {
        onSelect(selectedIds.filter((i) => i !== id));
    }

    return (
        <EmployeeProfileDropdown
            {...rest}
            id="seniority"
            onAdd={handleAdd}
            onRemove={handleRemove}
            selectedIds={selectedIds}
            emptyButtonText={{
                key: "si.account-overview.employee-profiles.seniorities-dd.button-text",
            }}
        />
    );
}

export default SenioritiesDropdown;
